// extracted by mini-css-extract-plugin
export default {"title":"Title-module__title--YTYH_","link":"Title-module__link--V_ia0"};